(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const money = cents => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(cents / 100);
  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-cart-scrim]');
  const toast = $('[data-toast]');
  let toastTimer;

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('cart-open');
    $('[data-close-cart]', drawer)?.focus();
    refreshCart();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('cart-open');
  };
  const showToast = message => {
    if (!toast) return;
    toast.lastChild.textContent = ` ${message}`;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  };
  async function refreshCart() {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const itemsNode = $('[data-cart-items]');
      if (!itemsNode) return;
      itemsNode.replaceChildren();
      cart.items.forEach(item => {
        const row = document.createElement('article'); row.className = 'cart-row';
        const thumb = document.createElement('div'); thumb.className = 'cart-thumb'; thumb.textContent = '🎁';
        const info = document.createElement('div'); info.className = 'cart-row-info';
        const name = document.createElement('strong'); name.textContent = item.product_title;
        const variant = document.createElement('small'); variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
        info.append(name, variant);
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (!value || key.startsWith('_')) return;
          const detail = document.createElement('small'); detail.className = 'cart-details'; detail.textContent = `${key}: ${value}`; info.append(detail);
        });
        const quantity = document.createElement('div'); quantity.className = 'quantity-control';
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'remove-item'; remove.textContent = 'Remove';
        remove.addEventListener('click', () => changeQuantity(item.key, 0)); quantity.append(remove); info.append(quantity);
        const price = document.createElement('strong'); price.className = 'cart-row-price'; price.textContent = money(item.final_line_price);
        row.append(thumb, info, price); itemsNode.append(row);
      });
      const empty = $('[data-cart-empty]'), summary = $('[data-cart-summary]');
      if (empty) empty.hidden = cart.item_count > 0;
      if (summary) summary.hidden = cart.item_count === 0;
      const subtotal = $('[data-cart-subtotal]'); if (subtotal) subtotal.textContent = money(cart.total_price);
    } catch (error) { console.error(error); }
  }
  async function changeQuantity(key, quantity) {
    await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    refreshCart();
  }
  async function addItems(items) {
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Could not add this selection.');
    showToast('Added a little joy to your bag!');
    openCart();
  }

  const menuButton = $('.menu-toggle'), menu = $('#primary-nav');
  menuButton?.addEventListener('click', () => {
    const expanded = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!expanded)); menuButton.setAttribute('aria-label', expanded ? 'Open navigation' : 'Close navigation'); menu?.classList.toggle('is-open', !expanded);
  });
  menu?.addEventListener('click', event => { if (event.target.closest('a')) { menu.classList.remove('is-open'); menuButton?.setAttribute('aria-expanded', 'false'); } });
  $$('[data-open-cart]').forEach(button => button.addEventListener('click', openCart));
  $$('[data-close-cart]').forEach(button => button.addEventListener('click', closeCart));
  scrim?.addEventListener('click', closeCart);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeCart(); });

  $$('[data-addon]').forEach(check => check.addEventListener('change', () => {
    const row = check.closest('.addon-row'); const field = $('.addon-subfield', row); const select = $('select', field || row);
    if (field) field.hidden = !check.checked;
    if (select) { select.disabled = !check.checked; select.required = check.checked; if (!check.checked) select.value = ''; }
    updateScoopTotal(check.closest('[data-scoop-card]'));
  }));
  $$('[data-addon-choice], [data-premium]').forEach(select => select.addEventListener('change', () => updateScoopTotal(select.closest('[data-scoop-card]'))));
  function updateScoopTotal(card) {
    if (!card) return;
    let total = Number(card.dataset.basePrice || 0);
    if ($('[data-addon="licensed"]', card)?.checked) total += 20;
    if ($('[data-addon="mystery"]', card)?.checked) { const size = $('[data-addon-choice="mystery"]', card)?.value; if (size === '800') total += 25; if (size === '1000') total += 35; }
    if ($('[data-addon="coloring"]', card)?.checked) total += 45;
    const totalNode = $('[data-total]', card);
    if (totalNode) totalNode.textContent = `Bundle total: ${money(total * 100)}`;
  }
  $$('[data-add-scoop]').forEach(button => button.addEventListener('click', async () => {
    const card = button.closest('[data-scoop-card]'); const tier = button.dataset.addScoop;
    const message = $('[data-scoop-message]'); if (message) message.textContent = '';
    const fail = text => { if (message) message.textContent = text; };
    const mainId = Number(card?.dataset.mainVariant);
    if (!mainId) return fail('Choose the matching Scoop product in the theme settings first.');
    const items = [{ id: mainId, quantity: 1, properties: { 'Scoop tier': `${tier} Scoop${tier === '1' ? '' : 's'}` } }];
    const premium = $$('[data-premium]', card).filter(select => select.value);
    const premiumFields = $$('[data-premium]', card);
    if (tier !== '1' && premiumFields.some(select => !select.value)) return fail('Choose your premium item selection first.');
    premium.forEach((select, index) => { items[0].properties[`Premium item ${index + 1}`] = select.value; });
    const licensed = $('[data-addon="licensed"]', card);
    if (licensed?.checked) {
      const character = $('[data-addon-choice="licensed"]', card)?.value;
      if (!character) return fail('Choose a character for the Opened Blind Box.');
      const id = Number(card.dataset.licensedVariant); if (!id) return fail('Select the Opened Blind Box product in theme settings.');
      items.push({ id, quantity: 1, properties: { Character: character, 'For scoop': `${tier} Scoops` } });
    }
    const block = $('[data-addon="mystery"]', card);
    if (block?.checked) {
      const size = $('[data-addon-choice="mystery"]', card)?.value;
      if (!size) return fail('Choose a Mystery Building Block Set size.');
      const key = size === '1000' ? 'block1000' : 'block800';
      const id = Number(card.dataset[`${key}Variant`]);
      const actualPrice = Number(card.dataset[`${key}Price`]);
      const expectedPrice = size === '1000' ? 3500 : 2500;
      if (!id) return fail(`Connect the ${size}+ Pieces variant in the Mystery Building Block Set product settings.`);
      if (actualPrice !== expectedPrice) return fail(`Set the ${size}+ Pieces Mystery Building Block Set variant price to $${size === '1000' ? '35' : '25'}.`);
      items.push({ id, quantity: 1, properties: { Set: `${size}+ Pieces`, 'For scoop': `${tier} Scoops` } });
    }
    const coloring = $('[data-addon="coloring"]', card);
    if (coloring?.checked) {
      const id = Number(card.dataset.coloringVariant);
      if (!id) return fail('Select the Coloring Set product in theme settings.');
      if (Number(card.dataset.coloringPrice) !== 4500) return fail('Set the Shopify Coloring Set product price to $45 so the cart total is correct.');
      items.push({ id, quantity: 1, properties: { Includes: '3 Coloring Books, 60 Dual Alcohol Marker Set, and 48 Dual Acrylic Marker Set', 'For scoop': `${tier} Scoops` } });
    }
    button.disabled = true;
    try { await addItems(items); } catch (error) { fail(error.message); } finally { button.disabled = false; }
  }));

  $('[data-add-beauty]')?.addEventListener('click', async event => {
    const button = event.currentTarget; const id = Number(button.dataset.variant); const choice = $('[data-beauty-choice]')?.selectedOptions[0]?.textContent.trim();
    if (!id) { showToast('Connect the Velvet Beauty Box product in theme settings to add it to cart.'); return; }
    try { await addItems([{ id, quantity: 1, properties: { 'Box option': choice } }]); } catch (error) { showToast(error.message); }
  });
  const budgetForm = $('#BudgetCornerRequest');
  budgetForm?.addEventListener('submit', event => {
    const data = new FormData(budgetForm);
    const amount = Number(data.get('budget') || data.get('contact[Budget]'));
    const error = $('[data-budget-error]', budgetForm);
    if (amount < 25) {
      event.preventDefault();
      error.textContent = 'The minimum budget is $25.';
      return;
    }
    error.textContent = '';
    const finds = data.getAll('finds').concat(data.getAll('contact[Favorite finds]'));
    const details = [
      'Budget Corner Request',
      `Name: ${data.get('name') || data.get('contact[name]')}`,
      `Email: ${data.get('email') || data.get('contact[email]')}`,
      `Budget: ${money(Math.round(amount * 100))}`,
      `Favorite character: ${data.get('character') || data.get('contact[Favorite character]')}`,
      `Favorite color: ${data.get('color') || data.get('contact[Favorite color]')}`,
      `Favorite finds: ${finds.length ? finds.join(', ') : 'No preference'}`,
      'Payment method: Zelle or Cash App (payment instructions requested by email)'
    ];
    $('[data-budget-message]', budgetForm).value = details.join('\n');
  });
  $('[data-showroom-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    const form = event.currentTarget;
    const error = $('[data-showroom-error]', form);
    const selected = $$('input[name="interests"]:checked', form).map(input => input.value);
    if (!selected.length) { error.textContent = 'Please select at least one interest so I can curate your showroom call.'; return; }
    error.textContent = '';
    const data = new FormData(form);
    const subject = `Lucky Luxe Zoom Showroom Request — ${data.get('name')}`;
    const body = [
      'I would like to schedule a 30-minute Lucky Luxe Scoops Zoom showroom experience.',
      '',
      `Name: ${data.get('name')}`,
      `Email: ${data.get('email')}`,
      `Preferred date: ${data.get('date')}`,
      `Preferred showing window: ${data.get('window')}`,
      `Interests: ${selected.join(', ')}`
    ].join('\n');
    window.location.href = `mailto:cloudciclesllc@outlook.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  });
  refreshCart();
})();
